export default "__VITE_ASSET__d390c45a__"